import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import openInNew from 'src/assets/images/lp/ic_open_in_new.svg';

export const ForDetailLink: React.FC<{ url: string }> = ({ url }) => {
  const { t } = useTranslation('resort');
  return (
    <a
      className={css`
        display: inline-block;
        background: white;
        font-size: 12px;
        text-align: center;
        border: 5px solid #eee17b;
        box-shadow: 0px 2px 0px #c7b52f;
        border-radius: 38px;
        color: #938666;
        position: relative;
        padding: 8px 40px;
        ::after {
          content: url(${openInNew});
          position: absolute;
          top: 50%;
          right: 16px;
          transform: translateY(-50%);
          height: 20px;
          width: 20px;
        }
        transition: transform 0.1s cubic-bezier(0.17, 0.89, 0.32, 1.49), color 0.2s;
        &:active {
          transform: scale(0.98, 0.95);
          box-shadow: 0px 1px 0px #c7b52f;
        }
        p {
          font-size: 16px;
          color: #4d3906;
        }
        @media (max-width: 370px) {
          span {
          }
        }
      `}
      target="_blank"
      rel="noopener noreferrer"
      role="button"
      href={url}
    >
      {t('for_detail_link_0')}
      <p>{t('for_detail_link_1')}</p>
    </a>
  );
};
